var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75540",
    "data-name": "Group 75540",
    transform: "translate(-213.209 -183.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71096",
    "data-name": "Path 71096",
    d: "M232.636,187.35l-9.091-3.692h0a.9.9,0,0,0-.673,0l-9.091,3.692h0a.91.91,0,0,0-.416.34.935.935,0,0,0-.156.518v6.922c0,6.83,9.164,12.118,9.555,12.339a.9.9,0,0,0,.909,0c.373-.221,9.536-5.51,9.536-12.339v-6.922a.932.932,0,0,0-.156-.518.91.91,0,0,0-.416-.34Zm-1.246,7.78c0,4.984-6.418,9.358-8.182,10.465-1.764-1.107-8.182-5.473-8.182-10.465v-6.294l8.182-3.322,8.182,3.322Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71097",
    "data-name": "Path 71097",
    d: "M290.521,315.745a.956.956,0,0,0,.681.289.94.94,0,0,0,.673-.289l6.5-6.6a.983.983,0,0,0,0-1.375.947.947,0,0,0-1.354,0l-5.821,5.909-1.743-1.77a.948.948,0,0,0-1.354,0,.983.983,0,0,0,0,1.375Z",
    transform: "translate(-70.031 -116.167)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.fa489cfa7079a618e502f5fbb1e4ee85.svg";
export { ForwardRef as ReactComponent };